import React, { useEffect, useState } from 'react'
import Navbar from '../Navbar';
import { Link, useParams } from 'react-router-dom';
import { IoSearch } from "react-icons/io5";
import axios from 'axios';
import { IoIosClose } from "react-icons/io";
import { toast } from 'react-toastify';
import { IoIosArrowDropdown } from "react-icons/io";
import { TbTableOptions } from "react-icons/tb";
import Cookies from 'js-cookie';
import { RiImportFill } from "react-icons/ri";
import Menu_Items from '../Menu_Items';

function In_Bound() {
    const { id, int_id, ib_id } = useParams();
    const [su_admin, setsu_admin] = useState(false)
    const [admin, setadmin] = useState(false)
    const [monitor, setmonitor] = useState(false)
    const [import_header, setimport_header] = useState([]);
    const [selected_header, setselected_header] = useState([]);
    const [alltables, setalltables] = useState([]);
    const [table_fields, settable_fields] = useState([]);
    const [value_none, setvalue_none] = useState([]);
    const [values, setvalues] = useState([]);
    const [search_file_headers, setsearch_file_headers] = useState('');
    const [search_header_mapping, setsearch_header_mapping] = useState('');
    const [header_mapping, setheader_mapping] = useState([]);
    const [values_mapping, setvalues_mapping] = useState([]);
    const [condition_deatils, setcondition_deatils] = useState([]);
    const [table_model, settable_model] = useState(false);


    const menus = [
        {
            name: "Integrations",
            id
        },
        {
            name: "In Bound",
            id,
            submenu: [
                { name: "Schedule", id, int_id, type: 'In' },
                (!monitor ? { name: "API", id, int_id } : {}),
                (!monitor ? { name: "Manual", id, int_id } : {})
            ]
        },
        (su_admin || admin ? { name: "Users", id } : {})
    ];

    const get_level = () => {
        const level = Cookies.get("level");
        if (level === "Super Admin") {
            setsu_admin(true);
        }
        else if (level === 'Admin') {
            setadmin(true)
        }
        else {
            setmonitor(true)
        }

    };
    const get_In_Bound_files = async () => {
        await axios.get(`/in_bound/details/files/tables/${ib_id}`).then((res) => {
            const { details, tables, file_data } = res.data;
            const keynames = file_data.flatMap(Object.keys);
            setimport_header([...new Set(keynames)]);
            setvalues(file_data);
            setalltables(tables);
            if (details.field_mapping) {
                let field_Mapping = JSON.parse(details.field_mapping);
                setheader_mapping(field_Mapping);
                let selected_Headers = field_Mapping.map((obj) => Object.keys(obj)[0]);
                setselected_header(selected_Headers)
            }
            if (details.values_mapping) {
                setvalues_mapping(JSON.parse(details.values_mapping));
            }
            if (details.conditions) {
                let condition = JSON.parse(details.conditions);
                setcondition_deatils(condition);
                let selected_tables = condition.map((obj) => Object.keys(obj)[0]);
                selected_tables.forEach(table => {
                    handle_table(table);
                });
            }
            else {
                if (details.field_mapping) {
                    let field_Mapping = JSON.parse(details.field_mapping);
                    const tableNames = [...new Set(field_Mapping.map(obj => Object.values(obj)[0].table))];
                    tableNames.forEach(table => {
                        handle_table(table);
                    });
                }
            }
        }).catch((err) => {
            toast.error('Error', {
                autoClose: 2000
            });
        })
    };
    const handle_header = (header) => {
        const exist = selected_header.includes(header);
        if (exist) {
            setselected_header(prev =>
                prev.filter(h => h !== header)
            );
        }
        else {
            setselected_header([...selected_header, header]);
        }
        setheader_mapping((prevdata) => prevdata.filter((obj) => obj[header] ? !obj[header] : obj));
        setvalues_mapping((prevdata) => prevdata.filter((obj) => obj[header] ? !obj[header] : obj));
    };
    const handleDragStart = (event, index) => {
        event.dataTransfer.setData("text/plain", index); // Store the index of the dragged item
    };
    const handleDrop = (event, dropIndex) => {
        const dragIndex = event.dataTransfer.getData("text/plain"); // Get the index of the dragged item
        const updatedHeaders = [...selected_header];

        // Move the dragged item to the new position
        const [movedItem] = updatedHeaders.splice(dragIndex, 1);
        updatedHeaders.splice(dropIndex, 0, movedItem);

        // Update the state
        setselected_header(updatedHeaders);
    };
    const handleDragOver = (event) => {
        event.preventDefault(); // Prevent default to allow drop
    };
    const handle_header_mapping = (file_header, e) => {
        const value = e.target.value;
        const [tname, header] = value.split(' --- ');
        // const exist = table_fields.some(item => table in item);
        // setheader_mapping
        const exist = header_mapping.some(item => file_header in item);

        if (!exist) {
            setheader_mapping(prevdata => [...prevdata, { [file_header]: { 'table': tname, 'header': header } }])
        }
        else {
            setheader_mapping((prevdata) => prevdata.map((obj) => {
                return obj[file_header] ? { [file_header]: { 'table': tname, 'header': header } } : obj
            }));
        }

    };
    const v_none = (vfield) => {
        const exist = value_none.includes(vfield);
        if (!exist) {
            setvalue_none([vfield]);
        }
        else {
            setvalue_none((prevdata) => prevdata.filter((val) => val !== vfield));
        }

    };
    const handle_value_mapping_input = (field, e) => {
        const { id, value } = e.target;
        if (value !== '') {
            const field_exist = values_mapping.some(item => field in item);

            if (field_exist) {
                setvalues_mapping((prevdata) =>
                    prevdata.map((obj) => {
                        if (field in obj) {
                            return {
                                ...obj,
                                [field]: obj[field].map((item) => {
                                    if (item.old === id) {
                                        return { old: id, new: value }; // Update existing entry
                                    } else {
                                        return item; // Return unchanged entry
                                    }
                                }).concat(obj[field].some(item => item.old === id) ? [] : [{ old: id, new: value }]) // Add new entry if it doesn't exist
                            };
                        }
                        return obj;
                    })
                );
            } else {
                // Add new field with old and new values
                setvalues_mapping([...values_mapping, { [field]: [{ old: id, new: value }] }]);
            }
        }
    };
    // File Headers
    const file_headers = import_header.filter(header =>
        header.toLowerCase().startsWith(search_file_headers.toLowerCase())
    );
    // Selected Headers
    const Selected_headers = selected_header.filter(header =>
        header.toLowerCase().startsWith(search_header_mapping.toLowerCase())
    );
    const handle_con_table = (tname, k_name, value) => {
        if (!value || value === "Select Field" || value === "Select Header") {
            // Optionally handle empty or default selections here
            return;
        }

        const exist = condition_deatils.some((item) => tname in item);
        if (!exist) {
            setcondition_deatils(prevdata => [...prevdata, { [tname]: { [k_name]: value } }]);
        } else {
            setcondition_deatils(prevdata =>
                prevdata.map((obj) => {
                    if (obj[tname]) {
                        return {
                            ...obj,
                            [tname]: {
                                ...obj[tname],
                                [k_name]: value
                            }
                        };
                    }
                    return obj;
                })
            );
        }
    };
    const handle_table = async (table) => {
        const exist = table_fields.some(item => table in item); // Check if the table exists in the current state

        if (!exist) {
            try {
                // Make the axios call to post data
                await axios.get(`/in_bound/table/fields/${table}/${ib_id}`).then((res) => {
                    let fields = res.data.map((obj) => {
                        return obj.Field;
                    });
                    // Update the state after the axios call resolves
                    settable_fields(prevdata => [...prevdata, { [table]: fields }]);
                })
                    .catch((err) => {
                        console.log('error');
                    });

            } catch (err) {
                toast.error('Error', {
                    autoClose: 2000
                });
            }
        } else {
            // If the item exists, filter it out and update the state
            settable_fields(prevdata => prevdata.filter(item => !(table in item)));
        }
    };
    const field_mapping_submit = async () => {
        await axios.patch(`/in_bound/field/mapping/${ib_id}`, header_mapping).then((res) => {
            toast.success(res.data, {
                autoClose: 2000
            });
        })
            .catch((err) => {
                toast.error('Error', {
                    autoClose: 2000
                });

            });
    };
    const values_mapping_submit = async () => {
        await axios.patch(`/in_bound/values/mapping/${ib_id}`, values_mapping).then((res) => {
            toast.success(res.data, {
                autoClose: 2000
            });
        })
            .catch((err) => {
                toast.error('Error', {
                    autoClose: 2000
                });

            });
    };
    const conditions_submit = async () => {
        if (condition_deatils && condition_deatils.length > 0) {
            await axios.patch(`/in_bound/conditions/${ib_id}`, condition_deatils).then((res) => {
                toast.success(res.data, {
                    autoClose: 2000
                });
            })
                .catch((err) => {
                    toast.error('Error', {
                        autoClose: 2000
                    });

                });
        }

    }
    const selected_condition = (tname, key) => {
        let value = condition_deatils.filter((obj) => obj[tname]);
        if (value.length > 0) {
            return value[0][tname][key];
        }

    };
    const retrive_field_mapping = (header) => {
        let field_map_values = header_mapping.filter((obj) => obj[header] ? obj[header] : '');
        if (field_map_values.length > 0) {
            return field_map_values[0][header];
        }
        else {
            return { table: "", header: '' }
        }


    };
    const retrive_value_mapping = (header, field) => {
        const headerMapping = values_mapping.find(obj => obj[header]);
        if (headerMapping) {
            const matchedObj = headerMapping[header].find(subObj => subObj.old === field);
            return matchedObj ? matchedObj.new : undefined; // Return 'null' if no match is found
        }
        return undefined

    }

    useEffect(() => {
        get_In_Bound_files();
        get_level();
    }, []);
    return (
        <div className='container df fdc ac'>
            <Navbar />
            <div className='main_box df'>
                <Menu_Items menu={menus} />
                <div className='content df fdc ac'>
                    <div className='page_header df jb ac'>
                        <div className='w90 df ac'>
                            <RiImportFill className='page_icon db' />
                            <p>In Bound Headers</p></div>
                        {
                            !monitor && <Link to={`#`} className='w5' ><TbTableOptions className='icon3 g' onClick={() => { settable_model(true) }} /></Link>
                        }
                    </div>
                    <div className='box df jc ac'>
                        <div className='t_box1'>
                            <div className='box1_h df jc ac'>
                                <p className='df jc ac'>Import Headers</p>
                            </div>
                            <div className='box_search df jc ac b0100' key={'1'}>
                                <div className='searchicon df jc ac'><IoSearch className='ser' /></div>
                                <input type='search' id='ser_table' placeholder='Search' value={search_file_headers} onChange={(e) => setsearch_file_headers(e.target.value)} />
                            </div>
                            <div className='h73 w100 df fdc ac b0100'>
                                {
                                    file_headers.length > 0 ? (file_headers.map((header, index) => {
                                        let Header = header.charAt(0).toUpperCase() + header.slice(1);
                                        return (
                                            <div key={`header${index}`} className='df gap h3 w80 ac cp'>
                                                <input type='checkbox' id={`${header}`} onChange={() => { handle_header(header) }} checked={selected_header.includes(header)} />
                                                <label htmlFor={`${header}`}>{Header}</label>
                                            </div>
                                        )
                                    })) : (
                                        <p className='no_Records h50 w100 df jc ac '>No results found</p>
                                    )
                                }
                            </div>
                        </div>
                        <div className='t_box2 '>
                            <div className='box1_h df jc ac'>
                                <p className='df jc ac'>Selected Headers</p>
                            </div>
                            <div className='box_search df jc ac b0100'>
                                <div className='searchicon df jc ac'><IoSearch className='ser' /></div>
                                <input type='search' id='ser_table' placeholder='Search' value={search_header_mapping} onChange={(e) => setsearch_header_mapping(e.target.value)} />
                            </div>
                            <div className='h73 w100 df fdc ac b0100'>
                                {
                                    Selected_headers.length > 0 && Selected_headers.map((sheader, index) => {
                                        let SHeader = sheader.charAt(0).toUpperCase() + sheader.slice(1);
                                        return (
                                            <div key={`sheader${index}`} className='df gap h3 w80 ac jb cp'
                                                draggable
                                                onDragStart={(event) => handleDragStart(event, index)}
                                                onDragOver={handleDragOver}
                                                onDrop={(event) => handleDrop(event, index)}
                                            >
                                                <label htmlFor={`${sheader}`}>{SHeader}</label>
                                                <IoIosClose className='r' onClick={() => handle_header(sheader)} />
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                        <div className='t_box3 '>
                            <div className='box1_h df jc ac'>
                                <p className='df jc ac'>Headers Mapping</p>
                            </div>
                            <div className='box_search df jc ac b0100'>
                                <div className='searchicon df jc ac'><IoSearch className='ser' /></div>
                                <input type='search' id='ser_table' placeholder='Search' value={search_header_mapping} onChange={(e) => setsearch_header_mapping(e.target.value)} />
                            </div>
                            <div className='h65 w100 df fdc ac of_a b0100'>
                                {
                                    Selected_headers.length > 0 && Selected_headers.map((sheader, index) => {
                                        let SHeader = sheader.charAt(0).toUpperCase() + sheader.slice(1);
                                        return (
                                            <div key={`header_mapping_${index}`} className='df gap h5 w90 ac jb cp'
                                                draggable
                                                onDragStart={(event) => handleDragStart(event, index)}
                                                onDragOver={handleDragOver}
                                                onDrop={(event) => handleDrop(event, index)}
                                            >
                                                <label className='w25' htmlFor={`${sheader}`}>{SHeader}</label>
                                                <select className='w50' onChange={(e) => { handle_header_mapping(sheader, e) }}>
                                                    <option>Select Header</option>
                                                    {
                                                        table_fields.length > 0 && table_fields.map((obj) => {
                                                            return Object.values(obj)[0].map((fnam) => {
                                                                let tableName = Object.keys(obj)[0].charAt(0).toUpperCase() + Object.keys(obj)[0].slice(1);
                                                                let Fname = fnam.charAt(0).toUpperCase() + fnam.slice(1);
                                                                return (
                                                                    <option value={`${Object.keys(obj)[0]} --- ${fnam}`} selected={retrive_field_mapping(sheader).table === Object.keys(obj)[0] && retrive_field_mapping(sheader).header === fnam}>{Fname}  -  {tableName}</option>
                                                                )
                                                            })

                                                        })
                                                    }
                                                </select>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            <div className='h7 w100 df jc ac b0100'>
                                {
                                    !monitor && header_mapping.length > 0 &&
                                    <button className='btn green' onClick={field_mapping_submit}>Submit</button>

                                }
                            </div>


                        </div>
                        <div className='t_box4'>
                            <div className='box1_h df jc ac'>
                                <p className='df jc ac'>Values Mapping</p>
                            </div>
                            <div className='box_search df jc ac'>
                                <div className='searchicon df jc ac'><IoSearch className='ser' /></div>
                                <input type='search' id='ser_table' placeholder='Search' />
                            </div>
                            <div className='h65 w100 df fdc ac of_a'>
                                {
                                    selected_header.length > 0 && selected_header.map((sheader, index) => {
                                        let SHeader = sheader.charAt(0).toUpperCase() + sheader.slice(1);
                                        return (
                                            <div key={`value_mapping_${index}`} className='w80 cp'
                                                draggable
                                                onDragStart={(event) => handleDragStart(event, index)}
                                                onDragOver={handleDragOver}
                                                onDrop={(event) => handleDrop(event, index)}
                                            >
                                                <div className='df jb ac h3'>
                                                    <label htmlFor={`${sheader}`} className='p'>{SHeader}</label>
                                                    <IoIosArrowDropdown className='db' onClick={() => v_none(sheader)} />
                                                </div>
                                                <div className={value_none.includes(sheader) ? `show w100 df fdc jc of_a gap` : `hide`} >
                                                    {
                                                        values.length > 0 ? (
                                                            [...new Map(
                                                                values
                                                                    .map((obj) => [obj[sheader], obj])
                                                            ).values()]
                                                                .sort((a, b) => (a[sheader] > b[sheader] ? 1 : -1))  // Sort in ascending order
                                                                .map((obj, index) => {
                                                                    if (obj[sheader]) {
                                                                        let value_map = retrive_value_mapping(sheader, obj[sheader]) || obj[sheader];
                                                                        return (
                                                                            <div className='h7 w100 df fdc jb' key={index}>
                                                                                <label htmlFor={obj[sheader]} className='h3'>{obj[sheader]}</label>
                                                                                <input
                                                                                    type='search'
                                                                                    id={obj[sheader]}
                                                                                    className='b1 h4'
                                                                                    defaultValue={value_map}  // 'value' should be lowercase
                                                                                    onChange={(e) => { handle_value_mapping_input(sheader, e) }}
                                                                                />
                                                                            </div>
                                                                        );
                                                                    }

                                                                })
                                                        ) : (
                                                            <p className='no_Records h50 w100 df jc ac '>No results found</p>
                                                        )
                                                    }

                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                            {
                                !monitor && values_mapping.length > 0 && <div className='h7 w100 df jc ac'>
                                    <button className='btn green' onClick={values_mapping_submit}>Submit</button>
                                </div>
                            }

                        </div>
                    </div>
                </div>
            </div>

            {
                table_model && <div className='model'>
                    <div className='h70 w80 white br1 df jb ac'>
                        <div className='h70 w20 df fdc ac '>
                            <div className='h5 w100 df jc ac h_blue br_f_1 fs08 '><p>Select Tables</p></div>

                            <div className='h65 w100 of_a b0100'>
                                <div className='box_search df jc ac'>
                                    <div className='searchicon df jc ac'><IoSearch className='ser' /></div>
                                    <input type='search' id='ser_table' placeholder='Search' />
                                </div>
                                {
                                    alltables && alltables.map((tnam, index) => {
                                        let tableName = tnam.charAt(0).toUpperCase() + tnam.slice(1);
                                        return (
                                            <div className='h3 pad0101 w100 df ac gap' key={`tnam${index}`}>
                                                <input type='checkbox' id={tnam} onChange={() => { handle_table(tnam) }} checked={table_fields.some(item => tnam in item)} />
                                                <label htmlFor={tnam}>{tableName}</label>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>
                        <div className='h70 w80 df fdc ac'>
                            <div className='h5 w100 p df jc ac h_blue br_l_1'><p>Set Conditions</p></div>
                            <div className='h55 w100 of_a df fdc gap ac'>
                                <div className='box_search df jc ac'>
                                    {/* <div className='searchicon df jc ac'><IoSearch className='ser' /></div>
                                    <input type='search' id='ser_table' placeholder='Search' /> */}
                                </div>
                                {
                                    table_fields.length > 0 ? (
                                        table_fields.map((obj, index) => {
                                            let tablename = Object.keys(obj)[0].charAt(0).toUpperCase() + Object.keys(obj)[0].slice(1);
                                            return (
                                                <>
                                                    <div className='h5 w100 df js ac' key={index}>
                                                        <div className='df fdc jb h4 w25' key={`con1_${index}`}>
                                                            <label htmlFor={tablename}>Primary Table</label>
                                                            <select value={tablename}>
                                                                <option>{tablename}</option>
                                                            </select>
                                                        </div>
                                                        <div className='df fdc jb h4 w25' key={`con2_${index}`}>
                                                            <label>Primary Field</label>
                                                            <select onChange={(e) => handle_con_table(Object.keys(obj)[0], 'field', e.target.value)} value={selected_condition(Object.keys(obj)[0], 'field')}>
                                                                <option>Select Field</option>
                                                                {
                                                                    obj[Object.keys(obj)[0]] ? (obj[Object.keys(obj)[0]].map((field) => {
                                                                        let Field = field.charAt(0).toUpperCase() + field.slice(1);
                                                                        return (
                                                                            <option value={field}>{Field}</option>
                                                                        )
                                                                    })) : (
                                                                        <option>N0 Fields</option>
                                                                    )
                                                                }
                                                            </select>
                                                        </div>
                                                        <div className='df fdc jb h4 w25' key={`con3_${index}`}>
                                                            <label>Primary File Header</label>
                                                            <select onChange={(e) => handle_con_table(Object.keys(obj)[0], 'header', e.target.value)} value={selected_condition(Object.keys(obj)[0], 'header')}>
                                                                <option>Select Header</option>
                                                                {
                                                                    file_headers.length > 0 ? (file_headers.map((header, index) => {
                                                                        let Header = header.charAt(0).toUpperCase() + header.slice(1);
                                                                        return (
                                                                            // 
                                                                            <option value={header}>{Header}</option>

                                                                        )
                                                                    })) : (
                                                                        <option>N0 Fields</option>
                                                                    )
                                                                }
                                                            </select>
                                                        </div>
                                                    </div>
                                                    {/* <div className='w100 t'></div> */}
                                                </>
                                            )

                                        })
                                    ) : (<p className='no_Records h50 w100 df jc ac '>No results found</p>)
                                }
                            </div>
                            <div className='h10 w80 df jc ac gap2'>
                                <button className='btn l_black' onClick={() => { settable_model(false); }}>close</button>
                                <button className='btn green' onClick={() => { settable_model(false); conditions_submit() }}>Submit</button>

                            </div>
                        </div>

                    </div>
                </div>
            }
        </div >
    )
}

export default In_Bound;